import axiosAgent from './axiosAgent';
import Apiconfig from '../config/ApiConfig';

export const getAllStudents = () =>
    axiosAgent
        .get(Apiconfig.users.getAllStudents)
        .then((response) => response.data.data);

export const getAllInstructors = () =>
    axiosAgent
        .get(Apiconfig.users.getAllInstructors)
        .then((response) => response.data.data);

export const getAllAssistants = () =>
    axiosAgent
        .get(Apiconfig.users.getAllAssistants)
        .then((response) => response.data.data);

// export const getAllUsers = () =>
//     axiosAgent.get(Apiconfig.statistics.getAllUsers)
//         .then((response) => response.data.data.users);
export const getAllUsers = async (page, limit, role) => {
    try {
        const response = await axiosAgent.get(
            `${Apiconfig.statistics.getAllUsers}?page=${page}&limit=${limit}&role=${role}`,
        );
        console.log('getAllUsers', response);
        return {
            users: response.data.data.users,
            total: response.data.data.total,
        };
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
